/* Afroyla DD DEAL — Crown Her Deals: ONE shelf at a time, swapping every 5 min (anh 09-25: 7 shelves × 5 min).
 * Feed: /collections/<feed>/products.json filtered by tag data-tag (dd-ongoing). Schedule + ranking live in
 * afroyla-dd-rotating-shelf-schedule-and-ranking.js. Header = shelf name + countdown + text list of the next 3 shelves.
 * Grid shows 12, "Show 12 more". Cards: price ("From $X" when variants differ) / compare-at, −% badge, Add to cart.
 * Multi-variant products: tapping Add to cart opens an in-card picker (variant + price), pick → adds. */
(function () {
  var A = window.AFDD;
  if (!A || !A.shelfState) return;
  var root = A.root;
  var grid = root.querySelector('[data-add-grid]');
  var head = root.querySelector('[data-add-shelf]');
  var sticky = root.querySelector('[data-add-shelf-sticky]'); // countdown strip that sticks while scrolling the grid
  var TAG = root.dataset.tag;
  var PAGE = 12;
  var byId = {};
  var byShelf = {};   // shelf key → ranked items
  var cur = { slot: -1, shown: PAGE, st: null };

  function loadFeed(page, acc) {
    return fetch('/collections/' + encodeURIComponent(root.dataset.feed) + '/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        acc.push.apply(acc, j.products || []);
        return (j.products || []).length === 250 && page < 6 ? loadFeed(page + 1, acc) : acc;
      });
  }

  function toItem(p) {
    var vars = p.variants.map(function (v) {
      return { id: v.id, name: v.title, price: +v.price, compare: +(v.compare_at_price || 0), available: v.available };
    });
    var avail = vars.filter(function (v) { return v.available; });
    var cheapest = (avail.length ? avail : vars).reduce(function (m, v) { return v.price < m.price ? v : m; });
    return {
      id: p.id, h: p.handle, t: A.cleanTitle(p.title), img: p.images && p.images[0] ? p.images[0].src : '',
      type: p.tags.filter(function (t) { return t.indexOf('dd-type-') === 0; })[0] || '',
      vars: vars, cheapest: cheapest, avail: avail.length > 0,
      minPrice: Math.min.apply(null, vars.map(function (v) { return v.price; })),
      maxSave: Math.max.apply(null, vars.map(function (v) { return Math.max(0, v.compare - v.price); }))
    };
  }

  function rel(ms) {
    var m = Math.max(1, Math.ceil(ms / 60000));
    return m < 60 ? 'in ' + m + ' min' : 'in ' + Math.floor(m / 60) + ' h ' + (m % 60) + ' min';
  }

  function cardHtml(it) {
    var v = it.cheapest;
    var off = A.pct(v.price, v.compare);
    var url = '/products/' + it.h;
    var spread = it.vars.some(function (x) { return x.price !== v.price; });
    return '<article class="add-card' + (it.avail ? '' : ' is-soldout') + '" data-card="' + it.id + '">' +
      '<a class="add-card__media" href="' + url + '" data-hc-el="collection-card-image">' +
        '<img src="' + A.img(it.img, 540) + '" alt="' + A.esc(it.t) + '" loading="lazy" width="540" height="720">' +
        (off ? '<span class="add-badge">−' + off + '%</span>' : '') + (it.avail ? '' : '<span class="add-soldout">Sold out</span>') + '</a>' +
      '<div class="add-card__body">' +
        '<a class="add-card__title" href="' + url + '" data-hc-el="collection-card">' + A.esc(it.t) + '</a>' +
        '<p class="add-price">' + (spread ? '<span class="add-price__from">From</span> ' : '') + '<span class="add-price__now">' + A.money(v.price) + '</span>' +
          (v.compare > v.price ? ' <s class="add-price__was">' + A.money(v.compare) + '</s>' : '') + '</p>' +
        '<div class="add-card__act" data-act="' + it.id + '">' +
          '<button type="button" class="add-btn" data-add-card="' + it.id + '"' + (it.avail ? '' : ' disabled') + ' data-hc-el="x-dd-card-add">' +
            (it.avail ? 'Add to cart' : 'Sold out') + '</button>' +
        '</div>' +
      '</div></article>';
  }

  // In-card variant picker, shown only after the shopper taps Add to cart on a multi-variant product
  function pickerHtml(it) {
    var labels = A.variantLabels(it.vars.map(function (x) { return x.name; }), true);
    return '<p class="add-pick__k">Choose one <button type="button" class="add-pick__x" data-pick-close="' + it.id + '" aria-label="Cancel">×</button></p>' +
      '<div class="add-pick">' + it.vars.map(function (x, k) {
        return '<button type="button" class="add-var" data-pick="' + x.id + '" data-pid="' + it.id + '"' + (x.available ? '' : ' disabled') +
          ' data-hc-el="variant-picker">' + A.esc(labels[k]) + ' <b>' + A.money(x.price) + '</b></button>';
      }).join('') + '</div>';
  }
  function actBox(id) { return grid.querySelector('[data-act="' + id + '"]'); }
  function closePicker(id) { var el = grid.querySelector('[data-card="' + id + '"]'); if (el) el.outerHTML = cardHtml(byId[id]); }

  function renderGrid() {
    var list = byShelf[cur.st.shelf.key] || [];
    var html = list.slice(0, cur.shown).map(cardHtml).join('') || '<p class="add-grid__msg">This shelf is sold out. The next one is coming up.</p>';
    if (list.length > cur.shown) {
      html += '<div class="add-more"><button type="button" class="add-btn add-btn--ghost" data-add-more data-hc-el="load-more">Show ' +
        Math.min(PAGE, list.length - cur.shown) + ' more (' + (list.length - cur.shown) + ' left)</button></div>';
    }
    grid.innerHTML = html; // manual "Show more" only, so the Good-to-know terms stay reachable
  }

  // Header: what's on now + countdown, then the next 3 shelves as a plain text list (anh 09-25: text, not photos)
  function renderHead() {
    var st = cur.st;
    var upcoming = [];
    for (var k = 1; k <= 3; k++) {
      var j = (st.idx + k) % A.SHELVES.length;
      if (st.nextTimeOf(j) >= A.END) break;
      upcoming.push({ shelf: A.SHELVES[j], j: j });
    }
    head.innerHTML =
      '<div class="add-shelf__now">' +
        '<p class="add-shelf__k">' + (st.pre ? 'First shelf opens at ' + A.esc(A.whenLabel(A.START)) : 'On the shelf now') + '</p>' +
        '<h3 class="add-shelf__name">' + A.esc(st.shelf.label) + '</h3>' +
        '<p class="add-shelf__timer"><span data-shelf-lbl></span> <b data-shelf-left></b></p>' +
        '<p class="add-shelf__note">See something she&#39;d love? <b>Add it to your cart now</b> to hold your deal — the price stays until ' + A.esc(A.whenLabel(A.END - 60000)) + ', but stock can run out.</p>' +
      '</div>' +
      (upcoming.length ? '<ol class="add-shelf__list">' + upcoming.map(function (u, i) {
        return '<li' + (i === 0 ? ' class="is-next"' : '') + '><span>' + (i === 0 ? 'Next' : 'Then') + '</span> <b>' + A.esc(u.shelf.label) + '</b> <em data-shelf-at="' + u.j + '"></em></li>';
      }).join('') + '</ol>' : '');
    sticky.innerHTML = '<span class="add-shelf-sticky__name">' + A.esc(st.shelf.label) + '</span><span class="add-shelf-sticky__t"><span data-shelf-lbl></span> <b data-shelf-left></b></span>';
    sticky.hidden = st.pre;
    tickHead();
  }

  // per-second: countdown + relative "in X min" (no time-zone math for the shopper)
  function tickHead() {
    var st = cur.st, now = A.now();
    var target = st.pre ? A.START : st.hasNext ? st.endsAt : A.END;
    var lbl = st.pre ? 'Opens in' : st.hasNext ? 'Next shelf in' : 'Sale ends in', left = st.pre ? A.hms(target - now) : A.mmss(target - now);
    root.querySelectorAll('[data-add-shelf] [data-shelf-lbl], [data-add-shelf-sticky] [data-shelf-lbl]').forEach(function (el) { el.textContent = lbl; });
    root.querySelectorAll('[data-add-shelf] [data-shelf-left], [data-add-shelf-sticky] [data-shelf-left]').forEach(function (el) { el.textContent = left; });
    head.querySelectorAll('[data-shelf-at]').forEach(function (el) { el.textContent = rel(st.nextTimeOf(+el.dataset.shelfAt) - now); });
  }

  function tick() {
    if (A.phase() === 'ended') return;
    var st = A.shelfState(A.now());
    if (st.slot !== cur.slot || st.pre !== (cur.st && cur.st.pre)) {
      var inside = cur.slot > -1 && grid.getBoundingClientRect().top < 0;
      cur.slot = st.slot; cur.st = st; cur.shown = PAGE;
      renderHead(); renderGrid();
      if (inside) {
        head.scrollIntoView({ block: 'start' }); // shopper was mid-grid: bring them to the new shelf's header
        grid.classList.remove('is-swapping'); void grid.offsetWidth; grid.classList.add('is-swapping');
      }
    } else tickHead();
  }

  grid.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-pick]');
    if (pick) {
      var pid = pick.dataset.pid;
      A.runAdd(pick, Number(pick.dataset.pick), A.img(byId[pid].img, 300));
      setTimeout(function () { closePicker(pid); }, 1300); // picker folds back into the button after the add settles
      return;
    }
    var close = e.target.closest('[data-pick-close]');
    if (close) { closePicker(close.dataset.pickClose); return; }
    var add = e.target.closest('[data-add-card]');
    if (add) {
      var it = byId[add.dataset.addCard];
      if (it.vars.length > 1) { actBox(it.id).innerHTML = pickerHtml(it); return; }
      A.runAdd(add, it.cheapest.id, A.img(it.img, 300));
      return;
    }
    if (e.target.closest('[data-add-more]')) { cur.shown += PAGE; renderGrid(); }
  });

  loadFeed(1, [])
    .then(function (products) {
      var items = products.filter(function (p) { return p.tags.indexOf(TAG) > -1; }).map(toItem);
      items.forEach(function (it) { byId[it.id] = it; });
      A.SHELVES.forEach(function (s) {
        byShelf[s.key] = A.rankShelf(items.filter(function (it) { return s.types.indexOf(it.type) > -1; }), s);
      });
      tick();
      setInterval(tick, 1000);
    })
    .catch(function () { grid.innerHTML = '<p class="add-grid__msg">Deals are loading slowly. Please refresh the page.</p>'; });
})();
